import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import Input from '../Common/Input';
import Select from '../Common/Select';
import InputMask from 'react-input-mask';
import moment from "moment-jalali";
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { useMemo } from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { NumericFormat } from 'react-number-format';

const inputTypeCase = [
    {
        id: 0,
        type: "متن",
        title: ""
    }, {
        id: 1,
        type: "عدد",
        title: ""
    }, {
        id: 2,
        type: "تاریخ",
        title: ""
    }
]


const Form = ({ formik, createDate, setCreateDate,
    groupList, setGroupList, activeList, id, idTemtValue,
    businessList, orgAddress, path, setPath,
    setOrgAddress, serviceList,
    setServiceList, discountsList, isEditMode }) => {

    let localDataId = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : {};
    let roleLocalId = localDataId?.roleId;

    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups')
    const { readDataByFilter: readDataService } = useEntityCrud('Service/GetAllServices')
    const { readData: readDataTemplate } = useEntityCrud('Template/GetAllTemplates')

    const [templateList, setTemplateList] = useState([])

    const businessAll = useMemo(() => businessList?.map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));
    const groupAll = useMemo(() => groupList?.map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));
    const serviceAll = useMemo(() => serviceList?.map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));

    const inputTypeListAll = useMemo(() => inputTypeCase?.map(item => ({ value: item.id, label: item.title, type: item.type })))



    useEffect(() => {
        const postedData = {
            buisnessId: orgAddress?.buisnessId.value,
        };
        readDataGroup(postedData).then(res => {
            if (res.data.result.length > 0) {
                setGroupList(res.data.result)
            }
        });
    }, [businessList, orgAddress?.buisnessId])


    useEffect(() => {

        const postedData = {
            groupId: orgAddress?.groupId.value,
        };
        readDataService(postedData).then(res => {
            if (res.data.result.length > 0) {
                setServiceList(res.data.result)
            }
        });
    }, [orgAddress?.groupId.value])



    useEffect(() => {
        readDataTemplate().then(res => {

            setPath(JSON.parse(res.data.result?.find(item => item.serviceId === orgAddress?.serviceId.value)?.fields))
        })
    }, [serviceList, orgAddress?.serviceId.value])


    useEffect(() => {

        if (path.length === 0)
            setPath([{
                type: "",
                title: "",
            },])
    }, [path])


    const handleChangeBusiness = (value) => {

        setOrgAddress(prevState => ({ ...prevState, serviceId: "" }))
        setOrgAddress(prevState => ({ ...prevState, groupId: "" }))
        setOrgAddress(prevState => ({ ...prevState, buisnessId: value }))
    }

    const handleChangeGroup = (value) => {
        setOrgAddress(prevState => ({ ...prevState, serviceId: "" }))
        setOrgAddress(prevState => ({ ...prevState, groupId: value }))
    }

    const handleChangeService = (value) => {
        setOrgAddress(prevState => ({ ...prevState, serviceId: value }))
    }


    function handleChange(value, key, index) {
        setPath(list => list.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    [key]: value,
                }
            } else return item;
        }))
    }

    const toBase64 = async file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const setFile = async e => {
        const file = e.target.files[0];
        const finalFile = await toBase64(file);
        formik.setFieldValue('image', finalFile);
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                {isEditMode === false && <div className="col-md-3" style={{ position: "relative", zIndex: "10" }}>
                    <label>
                        کسب و کار
                    </label>
                    <ReactSelect label="   کسب و کار"
                        required
                        options={businessAll.filter(item => item.isActive === true)}
                        value={orgAddress?.buisnessId}
                        onChange={handleChangeBusiness}
                        placeholder="انتخاب کنید"
                        name="buisnessId"
                    />
                </div>}
                {isEditMode === false && <div className="col-md-3" style={{ position: "relative", zIndex: "10" }}>
                    <label>
                        گروه
                    </label>
                    <ReactSelect label="گروه"
                        required
                        options={groupAll.filter(item => item.isActive === true)}
                        placeholder="انتخاب کنید"
                        name="groupId"
                        value={orgAddress?.groupId}
                        onChange={handleChangeGroup}
                    />
                </div>}
                {isEditMode === false && <div className="col-md-3" style={{ position: "relative", zIndex: "10" }}>
                    <label>
                        سرویس
                    </label>
                    <ReactSelect label="سرویس"
                        required
                        options={serviceAll.filter(item => item.isActive === 1)}
                        placeholder="انتخاب کنید"
                        name="serviceId"
                        value={orgAddress?.serviceId}
                        onChange={handleChangeService}
                    />
                </div>}

                <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                    <Input label="  عنوان محصول/خدمت    " name="title" formik={formik} required={true} />
                </div>

                {/*  {isEditMode === false && <div className='col-md-3' style={{ position: "relative", zIndex: "9" }}>
                    <div className="form-group">
                        <label htmlFor="createDate"> تاریخ ثبت     </label><br />

                        <DatePicker
                            name="createDate"
                            required
                            locale="fa"
                            shouldHighlightWeekends
                            value={createDate}
                            calendarPopperPosition={"bottom"}
                            onChange={(value) => {
                                setCreateDate(value)
                            }}
                            className="form-control"
                            inputPlaceholder=' تاریخ اتمام کارت هوشمند را انتخاب کنید ...'
                        />

                    </div>
                </div>
                } */}

                <div className="col-md-3" style={{ position: "relative", zIndex: "8" }}>
                    {/*                     <Input label=" قیمت  " name="price" formik={formik} required={true} />
 */}                    <div className="form-group">
                        <label>قیمت</label>
                        <NumericFormat
                            name="price"
                            className='form-control'
                            required={true}
                            value={formik.values.price}
                            isRtl={true}
                            {...formik.getFieldProps("price")}
                            thousandSeparator=","
                            allowNegative={false}
                        />

                    </div>
                </div>



                <div className="col-md-6" >
                    <Input label=" توضیحات  " name="description" formik={formik} />
                </div>
                <div className="col-md-3">
                    <div className="form-group">
                        <label>تصویر محصول</label>
                        {formik.values.imagePath && !formik.values.imagePath.toString().includes('undefined') && !formik.values.imagePath.toString().includes('null') ? <small className='text-primary mt-2' style={{ float: "left" }}
                            onClick={() => window.open(`https://petromah.sabinarya.com${formik.values.imagePath}`)}>مشاهده تصویر</small> : ''}
                        <input type="file" className="form-control" onChange={e => setFile(e)} />
                    </div>
                </div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <Select label="نوع موجودی" name="stockMode" formik={formik}>
                                    <option value="1">چند ساعتی (هر سه ساعت)</option>
                                    <option value="2">روزانه</option>
                                    <option value="3">ثابت</option>
                                </Select>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <Input label="میزان موجودی" name="stockQuantity" formik={formik} value={formik.values.stockQuantity} />
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <label>قوانین</label>
                        <textarea className="form-control" rows="5" value={formik.values.rules} onChange={e => formik.setFieldValue('rules', e.target.value)}></textarea>
                    </div>
                    <hr className="mt-5" />
                </div>
                {roleLocalId === 1 && <div className="col-12">
                    <h5><b>تخفیف</b></h5>
                    <div className="row">
                        <div className="col-md-3">
                            <label>درصد تخفیف</label>
                            <NumericFormat
                                name="discount"
                                className="form-control ltr-input"
                                value={formik.values.discount}
                                isRtl={true}
                                {...formik.getFieldProps("discount")}
                                onChange={e => formik.setFieldValue('discount', e.target.value > 100 ? 100 : e.target.value)}
                                maxLength={3}
                                allowNegative={false}
                            />
                        </div>
                    </div>
                    <hr className="mt-5" />
                    <h5><b>پیشنهاد ویژه</b></h5>
                    <div className="row">
                        <div className="col-md-2">
                            <label>قیمت ویژه</label>
                            <NumericFormat
                                name="specialPrice"
                                className="form-control ltr-input"
                                value={formik.values.specialPrice}
                                isRtl={true}
                                {...formik.getFieldProps("specialPrice")}
                                thousandSeparator=","
                                allowNegative={false}
                            />
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>از تاریخ</label>
                                <InputMask mask="9999/99/99" className="form-control ltr-input" style={{ height: 38.2 }} value={formik.values.specialFromDate} onChange={e => formik.setFieldValue('specialFromDate', e.target.value)} />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>از ساعت</label>
                                <InputMask mask="99:99" className="form-control ltr-input" style={{ height: 38.2 }} value={formik.values.specialFromTime} onChange={e => formik.setFieldValue('specialFromTime', e.target.value)} />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>تا تاریخ</label>
                                <InputMask mask="9999/99/99" className="form-control ltr-input" style={{ height: 38.2 }} value={formik.values.specialtoDate} onChange={e => formik.setFieldValue('specialtoDate', e.target.value)} />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>تا ساعت</label>
                                <InputMask mask="99:99" className="form-control ltr-input" style={{ height: 38.2 }} value={formik.values.specialtoTime} onChange={e => formik.setFieldValue('specialtoTime', e.target.value)} />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>تعداد</label>
                                <NumericFormat
                                    name="specialQuantity"
                                    className="form-control ltr-input"
                                    value={formik.values.specialQuantity}
                                    isRtl={true}
                                    {...formik.getFieldProps("specialQuantity")}
                                    allowNegative={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>}
                {/*  {isEditMode === false && <div className="col-md-3">
                    <label >فعال؟</label>
                    <ReactSelect
                        placeholder="انتخاب کنید"
                        options={activeList}
                        required
                        name="activeId"
                        isSearchable={true}
                        value={formik.values.activeId}
                        isRtl={true}
                        onChange={value => formik.setFieldValue("activeId", value)}
                        noOptionsMessage={() => 'نام مورد نظر یافت نشد'}
                    />
                </div>} */}
            </div>


            {((orgAddress?.serviceId.value || id) && (path.find(item => item.title !== ""))) &&
                <div className='landing-page'>
                    <div id="faqs">

                        <div className="col-md-12 grid-item  px-0">
                            <div className="card bg-secondary-transparent p-0 reveal active">

                                <div className="card-header grid-link" data-bs-toggle="card-collapse">
                                    <a href="#" className="card-options-collapse h5 fw-bold card-title mb-0">
                                        <span className="me-3 fs-18 fw-bold text-secondary"> </span>
                                        <b>  تخصیص قالب به محصول / خدمت
                                        </b></a>
                                </div>

                                {path?.map((item, index) => {
                                    return <div className='d-flex align-items-center' key={index} style={{ paddingRight: "2%", borderRight: "5px solid #05c3fb" }}>
                                        <div className="col-md-12">

                                            <div className="row m-0">
                                                <div className="col-md-3 form-group">
                                                    <label> عنوان </label>
                                                    <input type="text" className="form-control " readOnly
                                                        onChange={(e) => handleChange(e.target.value, "title", index)}
                                                        value={item.title} />
                                                </div>
                                                <div className="col-md-3 form-group">
                                                    <label> نوع </label>
                                                    <select type="text" value={item.type} className="form-control" required disabled
                                                        onChange={(e) => handleChange(e.target.value, "type", index)} placeholder="Title">
                                                        <option></option>
                                                        {inputTypeListAll.map(item => <option key={item.value}>{item.type}</option>)}
                                                    </select>
                                                </div>
                                                <div className="col-md-3 form-group">
                                                    <label> مقدار </label>
                                                    <input type="text" className="form-control "
                                                        onChange={(e) => handleChange(e.target.value, "templateValues", index)}
                                                        value={item.templateValues} />
                                                </div>
                                            </div>
                                        </div>

                                        <hr />
                                    </div>;
                                }
                                )}

                            </div>
                        </div>

                    </div>
                </div>
            }

            <div className='mx-auto text-center my-4 py-4'>
                <button className="btn btn-success">ذخیره اطلاعات</button>
            </div>

        </form >
    );
}

export default Form;